var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"platform-footer platform-controls"},[_c('div',{staticClass:"controls"},[_c('div',{staticClass:"seperator"}),_c('div',{staticClass:"theme-button control-button",on:{"click":_vm.toggleTheme}},[_c('i',{staticClass:"trading"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }